import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import DashboardLayout from './DashboardLayout';
import ErrorLayout from './ErrorLayout';

import loadable from '@loadable/component';
import PrintLayout from './PrintLayout';
const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));

const Layout = () => {
  useEffect(() => {
    AuthBasicLayout.preload();
  }, []);

  return (
    <Router fallback={<span />}>
      <Switch>
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/authentication/basic" component={AuthBasicLayout} />
        <Route path="/print" component={PrintLayout} />
        <Route component={DashboardLayout} />
      </Switch>
    </Router>
  );
};

export default Layout;
